/**
 * FP3-035B-3 — Admin Service Fidelity page.
 * Thin wrapper around the shared `<ServiceFidelityOverview mode="admin" />`.
 * Lives at /admin/service-fidelity.
 *
 * FP3-119 — Fidelity-Off gating. When the viewer preference
 * `fidelity_monitoring="off"`, the sidebar hides this entry, but
 * bookmarks/direct URLs still resolve here. Render a compact
 * disabled state pointing back to Workspace Preferences instead of
 * mounting the (expensive) fidelity table.
 */
import { Link } from "react-router-dom";
import { GearSix, ChartPieSlice } from "@phosphor-icons/react";
import ServiceFidelityOverview from "@/components/reports/ServiceFidelityOverview";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export default function AdminServiceFidelity() {
  const { preferences } = useAuth();
  const isFidelityOff = preferences?.fidelity_monitoring === "off";
  if (isFidelityOff) {
    return (
      <div
        data-testid="admin-service-fidelity-disabled"
        className="max-w-xl mx-auto mt-16 px-6"
      >
        <div className="flex items-start gap-3 border border-[#E5E3DB] rounded-xl bg-white p-6">
          <div className="w-10 h-10 rounded-full bg-[#F3F1EC] flex items-center justify-center shrink-0">
            <ChartPieSlice size={20} weight="duotone" className="text-[#6B7280]" />
          </div>
          <div className="flex-1">
            <h1
              data-testid="admin-service-fidelity-disabled-title"
              className="text-[15px] font-semibold text-[#1F2937] heading-font"
            >
              Service Fidelity Monitoring is off
            </h1>
            <p className="text-[13px] text-[#6B7280] mt-1.5 leading-relaxed">
              Turn it on in Workspace Preferences to view service-fidelity
              monitoring. Underlying goals, sessions and progress are
              unchanged; this is only a viewer preference.
            </p>
            <div className="mt-4">
              <Link to="/account/workspace">
                <Button
                  data-testid="admin-service-fidelity-open-preferences"
                  size="sm"
                  variant="default"
                  className="gap-1.5"
                >
                  <GearSix size={14} weight="duotone" />
                  Open Workspace Preferences
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <ServiceFidelityOverview mode="admin" />;
}
